import * as React from "react";
import './widget.css'

const Contact: React.FC = () => {
  return (
      <section id="widget-contact" className="widget">
        <h2>Contact</h2>
        <div className="widget-content">
          <h3>Tax Help Desk</h3>
          <p>
            <a href="mailto:tax@clearstream.com">tax@clearstream.com</a>
          </p>
          <p>Phone: +352 -243 -3 2835</p>
        </div>
      </section>
  );
};

export default Contact;
